// src/main.ts
import { register } from 'swiper/element/bundle';
import 'swiper/css'; // importante para que se vea bien
register();

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig).catch(console.error);
